import { Component } from '@angular/core';

import { Router } from '@angular/router';
import { ConfirmOperationComponent } from '../../../@theme/components/confirm-operation/confirm-operation.component';
import { NbDialogService, NbToastrService, NbGlobalPhysicalPosition } from '@nebular/theme';
import { PeriodService } from './period.service';
import { ColumnStatusPeriodComponent } from './column-status-period.component';
import { ColumnBooleanPeriodComponent } from './column-boolean.component';

@Component({
  selector: 'ngx-period',
  templateUrl: './period.component.html',
  styleUrls: ['./period.component.scss'],
})
export class PeriodComponent {

  public periods = [];

  settings = {
    actions: {
      columnTitle: 'Ações',
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
    },
    mode: 'external',
    columns: {
      description: {
        title: 'Descrição',
        width: '300px',
        type: 'string',
      },
      status: {
        title: 'Status',
        type: 'custom',
        renderComponent: ColumnStatusPeriodComponent,
        filter: false,
        editable: false,
      },
      allowsOutOfDateCheckin: {
        title: 'Check-in fora da vigência',
        type: 'custom',
        renderComponent: ColumnBooleanPeriodComponent,
        width: '300px',
        filter: false,
        editable: false,
      },
      allowsOutOfDateOkr: {
        title: 'Criação OKRs fora da vigência',
        type: 'custom',
        renderComponent: ColumnBooleanPeriodComponent,
        width: '300px',
        filter: false,
        editable: false,
      },
      allowsOutOfDateEditOkr: {
        title: 'Edição OKRs fora da vigência',
        type: 'custom',
        renderComponent: ColumnBooleanPeriodComponent,
        width: '300px',
        filter: false,
        editable: false,
      },
    },
    noDataMessage: 'Nenhum registro encontrado',
  };

  constructor(private periodService: PeriodService, private router: Router, private dialogService: NbDialogService,
    private toastrService: NbToastrService) {
    this.getAll();
  }

  getAll() {
    this.periodService.query().toPromise().then(response => {
      this.periods = response.body;
    });
  }

  openCreateDialog() {
    this.router.navigate(['pages/admin/period', 'create']);
  }

  openEditDialog(event): void {
    this.router.navigate(['pages/admin/period', event.data.id]);
  }

  onDeleteConfirm(event): void {
    this.dialogService.open(ConfirmOperationComponent, {
      context: {
        title: 'Excluir Período',
        text: `Você realmente deseja excluir o período ${event.data.description} ?`,
        accent: 'danger'
      },
    }).onClose.subscribe(response => response.confirmed && this.delete(event.data.id));
  }

  delete(id) {
    this.periodService.delete(id).toPromise().then(response => {
      this.toastrService.show('Período', 'Excluído com sucesso',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.getAll();
    }).catch(err => {
      this.toastrService.show('Período', err.error.title,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });
  }


}
